import { PublicFilesPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import DocumentURLContext from 'modules/documents/components/Documents/List/DocumentURLContext'
import PublicCompanyDocuments from 'modules/documents/components/PublicCompanyDocuments'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

const PublicCompanyDocumentsPage = () => {
  const { navigation } = useNavigation()
  const session = useCurrentSession()
  const { loading, data, error } = useQuery(PublicFilesPageDocument, {
    variables: {
      companyId: session.company?.id,
    },
  })

  const canEditPublicDocuments =
    (data?.documents?._policies.companyEditPublicDocuments.can ||
      data?.documents?._policies.companyUseCompanyDocuments.can) ??
    false

  const canSeePublicDocuments = data?.documents?._policies.companySeePublicDocuments.can

  const deleteFeatureEnabled = data?.features?.featuresConnection?.nodes?.[0]?.enabled ?? false

  const documentRoutesContext = {
    show: (id: string | number) =>
      navigation.files.companyFiles.list.documentId.fullPath({ document_id: id }),
  }

  return (
    <DocumentURLContext.Provider value={documentRoutesContext}>
      <ResponsivePage.Body
        loading={loading}
        error={error}
        showHeader={false}
        authorized={canSeePublicDocuments}
      >
        <PublicCompanyDocuments
          canUploadDocument={canEditPublicDocuments}
          deleteFeatureEnabled={deleteFeatureEnabled}
        />
      </ResponsivePage.Body>
    </DocumentURLContext.Provider>
  )
}

export default PublicCompanyDocumentsPage
